import React, { PureComponent } from 'react'
import {connect} from 'react-redux'
import Button from '@material-ui/core/Button'
import CreateIcon from '@material-ui/icons/Create'
import DeleteIcon from '@material-ui/icons/Delete'
import StraightenIcon from '@material-ui/icons/Straighten'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import IconButton from '@material-ui/core/IconButton'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import TextField from '@material-ui/core/TextField'
import Toolbar from '@material-ui/core/Toolbar'
import { withStyles } from '@material-ui/core/styles'

const styles = theme => ({
    listItemText:{
        fontSize:'0.9em',
    }
})

class MeasureItem extends PureComponent {

    constructor(props) {
        super(props)
        this.noteField = React.createRef()
        this.calibrateField = React.createRef()
    
      }

    state = { 
        visibleDlgNote: false,
        visibleDlgDelete: false,
        visibleDlgCalibrate: false,
        calibrateMm: '',
    }

    showDlgNote = () => {
        this.setState({ visibleDlgNote: true })
    }
    
    hideDlgNote = () => {
        this.setState({ visibleDlgNote: false })
    }

    showDlgDelete = () => {
        this.setState({ visibleDlgDelete: true })
    }
    
    hideDlgDelete = () => {
        this.setState({ visibleDlgDelete: false })
    }

    showDlgCalibrate = () => {
        this.setState({ visibleDlgCalibrate: true, calibrateMm: '' })
    }

    hideDlgCalibrate = () => {
        this.setState({ visibleDlgCalibrate: false, calibrateMm: '' })
    }

    handleOnChangeNote = event => {
        this.setState({ note: event.target.value })
    }

    handleCalibrateMmChange = (event) => {
        this.setState({ calibrateMm: event.target.value })
    }

    confirmNote = (index) => {
        this.hideDlgNote()
        this.props.measurements[index].note = this.noteField.value
    }   

    confirmDelete = (index) => {
        this.hideDlgDelete()
        this.props.toolRemove(index)
    }

    confirmCalibrate = (index) => {
        const mm = Number(String(this.state.calibrateMm).replace(',', '.'))
        this.hideDlgCalibrate()
        if (typeof this.props.onCalibrate === 'function') {
            this.props.onCalibrate(index, mm)
        }
    }

    onEdit = () => {
        this.showDlgNote()
    }
    
    onDelete = () => {
        this.showDlgDelete()
    }

    onCalibrate = () => {
        this.showDlgCalibrate()
    }
    
    render() {    
        const { classes } = this.props

        const item = this.props.item
        let index = this.props.index
        let pText = ''
        let sText = ''
        const data = (item && item.data) || {}
        const fmt = (n, digits = 2) =>
          typeof n === 'number' && Number.isFinite(n) ? n.toFixed(digits) : '—'
        switch (item.tool) {
            case 'Length':
                pText = `${fmt(data.length)} ${data.unit || 'mm'}`
                sText = item.note
                break
            case 'Angle':
            case 'CobbAngle':
                pText = `${fmt(data.rAngle, 1)} °`
                sText = item.note
                break
            case 'EllipticalRoi':
            case 'RectangleRoi': {
                const stats = data.cachedStats || {}
                const suv = data.suv
                pText = <div>
                            <div> A: {fmt(stats.area)} mm² </div>
                            <div> M: {fmt(stats.mean)} {data.unit || ''} </div>
                            <div> SD: {fmt(stats.stdDev)} {data.unit || ''} </div>
                            {suv ? (
                              <div>
                                SUV μ {fmt(suv.mean)} / max {fmt(suv.max)} {suv.unit || ''}
                              </div>
                            ) : null}
                        </div>
                sText = item.note
                break
            }
            case 'FreehandRoi': {
                const msd = data.meanStdDev || {}
                const suv = data.suv
                pText = <div>
                            <div> A: {fmt(data.area)} mm² </div>
                            <div> M: {fmt(msd.mean)} {data.unit || ''} </div>
                            <div> SD: {fmt(msd.stdDev)} {data.unit || ''} </div>
                            {suv ? (
                              <div>
                                SUV μ {fmt(suv.mean)} / max {fmt(suv.max)} {suv.unit || ''}
                              </div>
                            ) : null}
                        </div>
                sText = item.note
                break
            }
            default:
                break    
        }

        const canCalibrate = item.tool === 'Length' && typeof this.props.onCalibrate === 'function'

        return (
            <div>
                <ListItem>
                    <ListItemText classes={{primary:classes.listItemText}} primary={pText} secondary={sText} />
                    <Toolbar>
                        {canCalibrate ? (
                          <IconButton edge="end" onClick={this.onCalibrate} title="Calibrar distancia conocida">
                            <StraightenIcon />
                          </IconButton>
                        ) : null}
                        <IconButton edge="end" onClick={() => this.onEdit(index)}>
                            <CreateIcon />
                        </IconButton>
                        <IconButton edge="end" onClick={() => this.onDelete(index)}>
                            <DeleteIcon />
                        </IconButton>
                    </Toolbar>
                </ListItem>
                
                { this.state.visibleDlgNote ?
                    <Dialog
                        open={this.state.visibleDlgNote}
                        onClose={this.hideDlgNote}
                        aria-labelledby="form-dialog-title"
                    >
                        <DialogTitle id="form-dialog-title">{"Note for measurement:"}</DialogTitle>
                        <DialogContent>
                            <TextField
                                autoFocus
                                margin="dense"
                                id="note"
                                label="Note"
                                type="text"
                                fullWidth
                                inputRef={this.noteField}
                                defaultValue={this.props.measurements[index].note}
                            />
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={this.hideDlgNote}>
                                Cancel
                            </Button>
                            <Button onClick={() => this.confirmNote(index)} color="primary">
                                Ok
                            </Button>
                        </DialogActions>
                    </Dialog>
                : null }

                { this.state.visibleDlgCalibrate ?
                    <Dialog
                        open={this.state.visibleDlgCalibrate}
                        onClose={this.hideDlgCalibrate}
                        aria-labelledby="calibrate-dialog-title"
                    >
                        <DialogTitle id="calibrate-dialog-title">Calibrar distancia conocida</DialogTitle>
                        <DialogContent>
                            <TextField
                                autoFocus
                                margin="dense"
                                id="calibrate-mm"
                                label="Distancia real (mm)"
                                type="number"
                                inputProps={{ min: 0, step: 'any' }}
                                fullWidth
                                value={this.state.calibrateMm}
                                onChange={this.handleCalibrateMmChange}
                            />
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={this.hideDlgCalibrate}>
                                Cancelar
                            </Button>
                            <Button onClick={() => this.confirmCalibrate(index)} color="primary">
                                Aplicar
                            </Button>
                        </DialogActions>
                    </Dialog>
                : null }

                { this.state.visibleDlgDelete ?
                    <Dialog
                        open={this.state.visibleDlgDelete}
                        onClose={this.hideDlgDelete}
                        aria-labelledby="alert-dialog-title"
                    >
                        <DialogTitle id="alert-dialog-title">{"Are you sure to delete the measurement?"}</DialogTitle>
                        <DialogActions>
                            <Button onClick={this.hideDlgDelete}>
                                Cancel
                            </Button>
                            <Button onClick={() => this.confirmDelete(index)} autoFocus>
                                Ok
                            </Button>
                        </DialogActions>
                    </Dialog>
                : null }
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        measurements: state.measurements,
    }
}

//export default connect(mapStateToProps, )(MeasureItem)
export default connect(mapStateToProps)(withStyles(styles)(MeasureItem))
